module.exports = __webpack_public_path__ + "static/media/challenge-background-init.e85df090.svg";